module.exports = __webpack_public_path__ + "assets/img/e242c9df01a7ec8d5ca1c4085af1f1b9.svg";